<template>
  <nav
    class="jps-global-jps-breadcrumbs breadcrumbs-clamp"
    :class="{
        'is-dark': isDarkNavigation,
        'is-under-project': isUnderProjectPage,
      }"
      aria-label="階層ナビゲーション"
    >
      <template
        v-for="(bc, i) in breadcrumbs"
        :key="bc.title.ja"
    >
      <BaseIcon v-if="i !== 0" name="mdi/slash-forward" size="size-6" class="jps-breadcrumbs-slash" />
      <BaseLink :to="bc.path" class="jps-breadcrumbs-text">{{ ls(bc.title) }}</BaseLink>
    </template>
  </nav>
</template>

<script lang="ts" setup>
interface Props {
  breadcrumbs: Link[]
}
const props = withDefaults(defineProps<Props>(), {
})
const { ls } = useI18n()
const isDarkNavigation = computed(() => false)
const isUnderProjectPage = computed(() => props.breadcrumbs.some(link => link.path === "/project"))
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-global-jps-breadcrumbs {
  height: 1.5rem;
  width: 100%;
  background-color: $jps-gray-100;
  padding: 0.25rem 0 0.25rem 1rem;
  font-size: $size-8;
  line-height: 1.125rem;

  &.breadcrumbs-clamp {
    display: none;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;

    @include is-tablet {
      display: -webkit-box;
    }
  }

  &.is-dark {
    background-color: $jps-gray-900;
    color: $white;
  }

  &.is-under-project {
    background-color: #15d197;

    * {
      color: $white;
    }
  }
}
.jps-breadcrumbs-text {
  display: inline;
  vertical-align: middle;
}
.jps-breadcrumbs-slash {
  margin: 0 4px;
  display: inline;
  vertical-align: middle;
}
</style>
